module.exports = __webpack_public_path__ + "static-portal/img/xzz-zlgl.cc1d902.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xzz-zlgl.jpg
// module id = iEsB
// module chunks = 4